import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
export interface FilterData {
  filter: string;
  AdvanceSearch: any;
}

@Component({
    selector: 'app-view-expense',
    templateUrl: './view-expense.component.html',
    styleUrls: ['./view-expense.component.css'],
    standalone: false
})
export class ViewExpenseComponent implements OnInit {
  url: string;
  expenseDetail: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  MsgType: number;
  DisplayMessage: string;
  FormSearchExpense: FormGroup;
  pageNumber: number;
  advanceSearchValue: any;
  RightsID: string;
  expenseCount: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  filteredData: any = [];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  allSelected: boolean = false;
  selectedAmount: number = 0;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService,private  toastr : ToastrService) {

    this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202026001') || this.RightsID.includes('202026021') || this.RightsID.includes('202026000')) {
      } else {
        window.location.href = "module/0";
      }

      this.expenseCount=0;
    this.pageNumber = 1;
    this.MsgType = 1; // Loading
    this.advanceSearchValue = "";
    this.FetchExpenseDetail('');
    this.FormSearchExpense = this.formBuilder.group({
      txtSearch: [''], advanceSearchValue: ['']
    });
    this.FormSearchExpense.get('txtSearch').valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged()
    )
    .subscribe(value => {
      this.filterTable(value);
    });
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null) {
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  OpenModal(url, cID, modelName, urld, NoticeID)    {
    if (NoticeID == null) {
      NoticeID = 0;
    }
    let myDate = Math.floor(Math.random() * 6) + 1 ;
    this.modalURL =  url + "/" + NoticeID + "/" + cID + "/" + myDate.toString();
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      window.addEventListener("message", this.receiveMessage, false); // commented this line because it is throwing and can not understood the logic
      this.modalURL = "filter/202026000" ; }
  }

  selectAll(){
    this.allSelected = !this.allSelected;
    this.filteredData.forEach(element => {
      element.isSelected = this.allSelected
    });
    this.onChangeSelection();
  }
  onChangeSelection(){
    this.selectedAmount = 0;
    this.filteredData.forEach(element => {
      if(element.isSelected){
        this.selectedAmount = this.selectedAmount + element.UnitRate;
      }
    });
  }


  Approveexpense(){
    if (this.filteredData.some(x => x.isSelected)) {
      this.alertService.showConfirmation('Approve Expense','Are you sure to Approve selected records ?').then((result) => {
        if (result) {
          let ApproveRecord = "";
          for(let i = 0; i < this.expenseDetail.length; i++) {
              if(this.expenseDetail[i].isSelected) {
                  if(ApproveRecord != "") {
                    ApproveRecord += ", ";
                  }
                  ApproveRecord += this.expenseDetail[i].ID;
              }
          }
        
          this.http.get(this.url + 'Dashboard/ApproveExpense?ApproveRecord=' + ApproveRecord)
          .subscribe( (data) =>   {
              if (data == null || data.toString() == "[]") {
                this.MsgType = 2; // No Data Found
                this.DisplayMessage = "No Data Found";
                this.expenseDetail = '';
                this.filteredData = [];
              } 
              else {
               
                this.MsgType = 0; // No Message
                this.expenseCount=1;
                this.FetchExpenseDetail('');
              }
            },
            (error) => {
               this.MsgType = 3; // Error Message
               this.DisplayMessage = error.message;
             }
          );
        }
      })
    }else{
      this.toastr.error('Please select at least one record to approve.');
    }
    
  }


  Rejectexpense(){
    if (this.filteredData.some(x => x.isSelected) ) {
      this.alertService.showConfirm('Are you sure to Reject selected records ?').then((result) => {
        if (result) {
          var RejectRecord = "";
          for(let i = 0; i < this.expenseDetail.length; i++) {
              if(this.expenseDetail[i].isSelected) {
                  if(RejectRecord != "") {
                    RejectRecord += ", ";
                  }
                  RejectRecord += this.expenseDetail[i].ID;
              }
          }
        
          this.http.get(this.url + 'Dashboard/RejectExpence?RejectRecord=' + RejectRecord)
          .subscribe( (data) =>   {
            
              if (data == null || data.toString() == "[]") {
                this.MsgType = 2; // No Data Found
                this.DisplayMessage = "No Data Found";
                this.expenseDetail = '';
              } 
              else {
                
                this.MsgType = 0; // No Message
                this.expenseCount=1;
                this.FetchExpenseDetail('');
              }
            },
            (error) => {
                this.MsgType = 3; // Error Message
                this.DisplayMessage = error.message;
              }
          );          
        }
      })
    } else {
      this.toastr.error('Please select at least one record to reject.');
    }
  }
  onSearchExpense(SearchData) {
    this.FetchExpenseDetail(SearchData.txtSearch);
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch')); }
    localStorage.setItem('advancesearch', "");
    this.FetchExpenseDetail('');
    this.modalURL = '' ;
  }
  FetchExpenseDetail(Param) {
    let filterData: FilterData = {
      filter: Param,
      AdvanceSearch: this.advanceSearchValue
     };
    this.http.post(this.url + 'Dashboard/SearchExpense', filterData)
    .subscribe( (data) =>   {
        if (data == null || data.toString() == "[]") {
          this.expenseDetail = null;
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.filteredData = [];
        } else {
          this.MsgType = 0; //  No Message
          this.expenseCount=1;
          this.expenseDetail = JSON.parse(data.toString());
          this.totalRecords = this.expenseDetail.length;
          this.filterTable('');
        }
       },
       (error) => {
          this.MsgType = 3; // Error Message
          this.DisplayMessage = error.message;
          this.expenseDetail = null;
        }
    );
  }
  DeleteExpense(ExpenseID) {
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if(result) {
        this.http.get(this.url + 'Notice/DeleteExpense?ExpenseID=' + ExpenseID)
        .subscribe( (data) =>   {
            if (data == null || data.toString() == "[]") {
              this.expenseDetail = null;
            } else {
              this.alertService.showSuccess('Successfully Deleted');
              this.FetchExpenseDetail('');
            }
           },
           (error) => {
              this.alertService.showWarning(error.message);
           }
        ); 
      }
    })
  }
  filterTable(txtSearch:string){
    if (!txtSearch) {
      this.filteredData = [...this.expenseDetail];
      return;
    }

    this.filteredData = this.expenseDetail.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(txtSearch)
      )
    );
  }
}
